import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Card, CardHeader, Text } from '@pancakeswap/uikit'

const StyledCard = styled(Card)`
  max-width: 80px;
  min-width: 72px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: baseline;
  position: relative;
  border-radius: 12px;
  color: ${({ theme }) => theme.colors.secondary};
  
  & > div {
    border-radius: 12px;
  }
`

const Wrapper = styled(CardHeader) <{ selected?: boolean; background?: string }>`
  cursor: pointer;
  background: ${({ selected, background, theme }) =>
  selected ? 'linear-gradient(111.68deg,#420b48 0%,#9bb8f9 100%)' : theme.colors.gradients[background]};
  border-radius: 8px;
  padding: 5px 5px 2px;
  position: relative;

  ${Text}:last-child {
    padding: 8px;
    line-height: 1.2;
  }

  &:hover {
    opacity: .6;
  }

  img {
    opacity: ${({ selected }) => selected ? '.7' : '1'};
  }
`

const StyledAvatarImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 12px;
`

const StyledTag = styled.h2`
  position: absolute;
  top: 4px;
  right: 4px;
  border-radius: 16px;
  padding: 2px 6px;
  font-size: 14px;
  background: #1e1a1abf;
  color: #fff;
  font-weight: normal;
`

const NftItem: React.FC<{ id: number; image: string; selected?: boolean; setSelected?: (flag: boolean) => void }> = ({ id, image, selected, setSelected  }) => {
  return (
    <StyledCard>
      <Wrapper selected={selected} onClick={() => { if (setSelected) setSelected(!selected); }}>
        <StyledAvatarImage src={`${image}`} />
        <StyledTag>
          {`#${id}`}
        </StyledTag>
      </Wrapper>
    </StyledCard>
  )
}

export default NftItem
